// extracted by mini-css-extract-plugin
export default {"form--double-column":"form_form--double-column__jgx8t","form--stretch":"form_form--stretch__eqMyV"};